import { Component, OnInit, Inject, AfterViewInit, ElementRef,HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { LayoutService } from './shared/services/layout.service';
import { AppService } from './shared/services/app.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {

  @HostListener('window:resize', ['$event'])
  onResize(event) {
       this.layoutService.menuactive();
  }

  @HostListener('window:orientationchange', ['$event'])
  onOrientationChange(event) {
      this.appService.detectIPadOrientation(this.appService,event.target.screen.orientation.angle);
  }

  @HostListener('window:touchstart', ['$event'])
  onTouchStart(event) {
      this.appService.storeDocumentData(event);
  }

  @HostListener('window:click', ['$event'])
  onWindowClick(event) {
    this.appService.storeDocumentData(event);

    this.appService.loadEvents(event,"click");
  }



  @HostListener('window:mouseenter', ['$event'])
  onWindowMouseEnter(event) {
    this.appService.loadEvents(event,"mouseenter");
  }

  @HostListener('window:mouseleave', ['$event'])
  onWindowMouseLeave(event) {
    this.appService.loadEvents(event, "mouseleave");
  }

  @HostListener('window:keyup', ['$event'])
  onWindowKeyUp(event) {
    this.appService.loadEvents(event, "keyup");
  }
 
  public allow_drawing_tool = ["/fk-rb-index",
    "/rbpagech",
    "/fk-storybook",
    "/fk-wb-index",
    "/wbpagech"];

  drawingToolStatus = false;

  
  public checkDrawingTool() {
    let allow_drawing_tool: any = this.allow_drawing_tool;
    var current_url = this.router.url;

    if (allow_drawing_tool.some(v => current_url.includes(v))) {
    
      return true;
    }
    
    return false;
  }

openNavParent(event)
{
  this.layoutService.openNav();
}
closeNavParent(event)
{
  this.layoutService.closeNav();
}

  constructor(public router: Router, private elementRef: ElementRef,public layoutService:LayoutService,public appService:AppService) {

    var thisme = this;
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        
        thisme.drawingToolStatus = thisme.checkDrawingTool();        
      }
    });

  }


  setDrawingToolLeft() {
    
  }



  public ngOnInit() {
    var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var userAgent = navigator.userAgent.toLowerCase();
    var android_dev = userAgent.indexOf("android") > -1;
    var chrome_browser = userAgent.indexOf("chrome") > -1;
    var samsung_browser = userAgent.indexOf("samsung") > -1;
    var msg = "no";
    if (isIOS) {
      var ipadmsg = "ipad";
      var body = document.body;
      body.classList.add(ipadmsg);
    }
     else if (android_dev) {
      msg = "android";

      if (samsung_browser) {
        msg = msg + "_samsung";
      }
      else if (chrome_browser) {
        msg = msg + "_chrome";

      }
      var body = document.body;
      body.classList.add(msg);
    }
  }

  private loadScript(scriptUrl: string, className: string) {
    return new Promise((resolve, reject) => {
      const scriptElement = document.createElement('script');
      scriptElement.src = scriptUrl;
      scriptElement.className = className;
      scriptElement.onload = resolve;
      document.body.appendChild(scriptElement);
    })
  }

  async ngAfterViewInit() {
    
    await this.loadScript('../assets/fk-commonjs/scripts/createjs_touch.js', "createjs_touch");
    this.initCustomTouchEvent();
      this.layoutService.initLayout();  
  }


  
  touchHandler(event: any) {
    var touch: any = event.changedTouches[0];
    var simulatedEvent: any = document.createEvent("MouseEvent");
    simulatedEvent.initMouseEvent({
      touchstart: "mousedown",
      touchmove: "mousemove",
      touchend: "mouseup"
    }[event.type], true, true, window, 1,
      touch.screenX, touch.screenY,
      touch.clientX, touch.clientY, false,
      false, false, false, 0, null);

    
    if ((event.type == "touchstart" || event.type == "touchmove" || event.type == "touchend") && (event.target.id == "canvas1")) {
      
    }
    else {
      
      touch.target.dispatchEvent(simulatedEvent);
      if (event.type != "touchend") {
        event.preventDefault();
      }
    }
  }

  initCustomTouchEvent() {

    document.removeEventListener("touchstart", this.touchHandler, true);
    document.removeEventListener("touchmove", this.touchHandler, true);
    document.removeEventListener("touchend", this.touchHandler, true);
    document.removeEventListener("touchcancel", this.touchHandler, true);

    document.addEventListener("touchstart", this.touchHandler, true);
    document.addEventListener("touchmove", this.touchHandler, true);
    document.addEventListener("touchend", this.touchHandler, true);
    document.addEventListener("touchcancel", this.touchHandler, true);
  }
 
}
